import React, { useMemo } from 'react';

import { TCommonProps, TActionsProps, TInlineEditProps, TForwardedRef } from 'types/gridDefs';
import { TColumns } from 'types/columnDefs';

import { DataGridBase } from './DataGrid/DataGrid.Base';
import { GetActionsColumn } from './Columns/Actions.Column';
import { ErrorBoundary } from './Error/ErrorBoundary';

/* ======================================== */

type TProps = TCommonProps & TActionsProps & TInlineEditProps;

/* ======================================== */

/**
 * adserve DataGrid with an Actions column and inline row editing support
 * !! prototype: still under development !!
 * @public
 */
export const AsDataGridActionsRowEdit = React.forwardRef<TForwardedRef, TProps>((props, forwardedRef) => {
    const { columns } = props;
    const { enableActions, onRowEdit, onRowCopy, onRowDelete } = props;

    /* -------------------- */

    const actionColumns: TColumns = useMemo(() => (
        [GetActionsColumn({ enableActions, onRowEdit, onRowCopy, onRowDelete }), ...(columns ?? [])]
    ), [columns, enableActions, onRowEdit, onRowCopy, onRowDelete]);

    /* -------------------- */

    return (
        <ErrorBoundary name='AsDataGridActionsRowEdit'>
            <DataGridBase
                {...props}
                ref={forwardedRef}
                columns={actionColumns}
                editMode='row'
            />
        </ErrorBoundary>
    );
});
